export const en = {
    GENERAL_DELETE: 'Delete',
    GENERAL_CANCEL: 'Cancel',
    GENERAL_SAVE: 'Save',
    GENERAL_SETTINGS: 'Settings',
    JSON_EDITOR_REVISION_ACTIVE: 'active',
    JSON_EDITOR_REVISION_DELETE_CONFIRM: 'Really delete revision?',
    JSON_EDITOR_REVISION_SAVE_SUCCESS: 'Revision saved',
    JSON_EDITOR_REVISION_SAVE_FAILURE: 'Revision was not saved',
    JSON_EDITOR_REVISION_DELETE_SUCCESS: 'Revision deleted',
    JSON_EDITOR_REVISION_DELETE_FAILURE: 'Revision was not deleted',
    JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED: 'Active revisions cannot be saved',
    JSON_EDITOR_REVISION_ACTIVATE_SUCCESS: 'Revision activated',
    JSON_EDITOR_REVISION_ACTIVATE_FAILURE: 'Revision was not activated',
    JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION: 'Cannot change already approved revision',
    JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS: 'Cannot change revision of other admins',
    JSON_EDITOR_INVALID_JSON: 'Invalid JSON',
    MISSING_APPROVAL_PERMISSION: "You don't have permission to approve revisions.",
    DIRECTIVE_PHONE_PRESET_CONFIGURE_GLOBAL: 'Configure phone preset globally?',
    DIRECTIVE_CHECK_BEFORE_EXPORT_ENABLED: 'Reports must be checked before export to integration',
    DIRECTIVE_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Configure preferences globally?',
    DIRECTIVE_APP_CRM_CONNECTION_DISABLED: 'Deactivate CRM-Connection in Business Cards Scanner App',
    DIRECTIVE_EXPORT_SETTINGS_DIRECT_EXPORT: 'Save contact data directly to selected integration (CRM system).',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Configure automatic export globally?',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_ENABLED: 'Activate automatic export',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_TIMEOUT: 'Execute automatic export after minutes of inactivity',
    DIRECTIVE_SELECT_INTEGRATION_CHOOSE: 'Integration Settings',
    DIRECTIVE_SELECT_INTEGRATION_CRM_HEADER: 'CRM systems:',
    DIRECTIVE_SELECT_INTEGRATION_EMAIL_HEADER: 'Email integrations:',
    DIRECTIVE_SELECT_INTEGRATION_MA_HEADER: 'Marketing automations:',
    DIRECTIVE_SELECT_INTEGRATION_OTHER_HEADER: 'Other integrations:',
    DIRECTIVE_VISITREPORT_MANDATORY_CONFIGURE_GLOBAL: 'Configure mandatory contact-fields globally?',
    INTEGRATION_MODAL_SNAPADDY_API_HEADER: 'snapAddy API settings',
    INTEGRATION_MODAL_SNAPADDY_API_ENDPOINT_URL: 'Endpoint-URL',
    INTEGRATION_MODAL_SNAPADDY_API_HTTP_METHOD: 'HTTP method',
    INTEGRATION_MODAL_SNAPADDY_API_AUTH_HEADER: 'Authorization-Header',
    INTEGRATION_MODAL_WECLAPP_HEADER: 'Weclapp settings',
    INTEGRATION_MODAL_SUGAR_HEADER: 'SugarCRM settings',
    INTEGRATION_MODAL_SUITE_HEADER: 'SuiteCRM settings',
    INTEGRATION_MODAL_SUGAR_USE_V41: 'I use Sugar Community Edition',
    INTEGRATION_MODAL_CENTRALSTATION_HEADER: 'CentralStationCRM settings',
    INTEGRATION_MODAL_SAPC4C_HEADER: 'SAP Sales Cloud settings',
    INTEGRATION_MODAL_SAGE_HEADER: 'Sage CRM settings',
    INTEGRATION_MODAL_DYNAMICS_HEADER: 'Microsoft Dynamics settings',
    INTEGRATION_MODAL_ZAPIER_HEADER: 'Zapier settings',
    INTEGRATION_MODAL_SUITE_EXPORT_2: 'CRM Export 2.0 activated',
    INTEGRATION_MODAL_SUITE_PLAINTEXT_PASSWORD: 'Send password in plaintext (Password will not be saved)',
    INTEGRATION_MODAL_GENERIC_ENDPOINT_URL: 'Endpoint-URL',
    INTEGRATION_MODAL_OPTIVO_HEADER: 'Episerver Campaign settings',
    INTEGRATION_MODAL_OPTIVO_AUTHTOKEN: 'Authorizationcode',
    INTEGRATION_MODAL_OPTIVO_AUTO_EXPORT: 'Automatically send reports to Episerver Campaign after checking',
    INTEGRATION_MODAL_OPTIVO_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/episerver-campaign-authorization-code-and-mailingid',
    INTEGRATION_MODAL_MANDRILL_HEADER: 'Mandrill/MailChimp settings',
    INTEGRATION_MODAL_MANDRILL_API_KEY: 'API Key',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_TEMPLATE: 'Default template name',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_EMAIL: 'Default sender e-mail',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_NAME: 'Default sender name',
    INTEGRATION_MODAL_MANDRILL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/mandrill-api-key-and-template-name',
    INTEGRATION_MODAL_RAPID_MAIL_HEADER: 'RapidMail settings',
    INTEGRATION_MODAL_RAPID_MAIL_USER_NAME: 'API Username',
    INTEGRATION_MODAL_RAPID_MAIL_PASSWORD: 'API Password',
    INTEGRATION_MODAL_RAPID_MAIL_INVALID_CREDENTIALS: 'Please enter valid RapidMail API User Credentials',
    INTEGRATION_MODAL_RAPID_MAIL_AUTO_EXPORT: 'Automatically send reports to RapidMail after checking',
    INTEGRATION_MODAL_RAPID_MAIL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/rapidmail-api-user-api-password-and-recipient-list-id',
    INTEGRATION_MODAL_HUBSPOT_HEADER: 'Hubspot settings',
    INTEGRATION_MODAL_HUBSPOT_API_KEY: 'API Key',
    INTEGRATION_MODAL_HUBSPOT_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/hubspot-access-token',
    INTEGRATION_MODAL_SET_DEFAULT_CRM: 'Set as default CRM',
    INTEGRATION_MODAL_SALESFORCE_HEADER: 'Salesforce settings',
    INTEGRATION_MODAL_CLOSEIO_HEADER: 'Close.io settings',
    INTEGRATION_MODAL_OUTLOOK_HEADER: 'Outlook settings',
    REMOVE_SETTINGS_REQUEST: 'Do you want to remove the settings permanently?',
    INT_DYNAMICS_OAUTH_LOGIN: 'Connect via OAuth',
    INT_DYNAMICS_OAUTH_LOGIN_RESTRICTION: '(only for Dynamics CRM 365 Online)',
    INT_DYNAMICS_USE_API: 'Use API connection',
    INT_DYNAMICS_USE_LINK: 'Use URL export (without duplicate check)',
    INT_DYNAMICS_WEB_SESSION: 'Use existing Websession',
    INT_DYNAMICS_WINDOWS: 'Use windows-login',
    INT_SAP_LOGIN_TYPE: 'Connection type',
    INT_SAP_OAUTH_CLIENT_ID: 'OAuth Client ID',
    INT_SAP_OAUTH_CLIENT_SECRET: 'OAuth Client Secret',
    INT_SAP_USE_WEBSESSION: 'Use existing Websession',
    INT_SAP_USE_OAUTH: 'OAuth 2.0 via SAML Bearer Assertion',
    INT_SAP_ENTITY_ID: 'Entity ID',
    INTEGRATION_MODAL_GENERIC_PLEASE_CHOOSE: 'Please choose ...',
    Salutation: 'Salutation',
    Title: 'Title',
    Vorname: 'Name',
    Nachname: 'Lastname',
    Firma: 'Company',
    Funktion: 'Job title',
    Straße: 'Street',
    Adresszusatz: 'Address line 2',
    PLZ: 'Zip',
    Ort: 'City',
    Telefon: 'Phone',
    Mobile: 'Mobile',
    Fax: 'Fax',
    'E-Mail': 'E-mail',
    Website: 'Website',
    Land: 'Country',
    Bundesland: 'State',
    Kontaktdaten: 'Contact details',
};
